import React, { useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/bthTriangle.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { format, parse } from "date-fns";

const serviceType = [
  { value: "1", label: "Mobile" },
  { value: "2", label: "DTH" },
];

const CustReportFilterModal = ({
  show,
  handleClose,
  setRechargeData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
  filterData,
  setFilterData,
  handleReset,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...filterData,
      companyCode: filterData.companyCode || "",
      fromDate: filterData.fromDate || "",
      toDate: filterData.toDate || "",
      fromAmount: filterData.fromAmount || "",
      toAmount: filterData.toAmount || "",
      billerCategory: filterData.billerCategory || null,
      billerName: filterData.billerName || "",
      billerStatus: filterData.billerStatus || [],
      firstContactPersonMobileNo: filterData.firstContactPersonMobileNo || "",
    },
    mode: "onChange",
  });

  const [selectedTab, setSelectedTab] = useState("Company Code");

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");

  const onSubmit = () => {
    fetchCustomerData(currentPage);
  };

  const fetchCustomerData = async (currentPage) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        ...filterData,
        billerCategory: filterData.billerCategory?.label || "",
        fromDate: formatDate(filterData.fromDate),
        toDate: formatDate(filterData.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_RECHARGE_DATA}?&pageSize=${pageSize}&pageNo=${1}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setRechargeData(modifiedData);
        setNoData(modifiedData?.length === 0);
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });

        setRechargeData([]);
        setNoData(true);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    const modified = response?.map((user, index) => {
      const transDateParsed = user?.transDate
        ? parse(user.transDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const formattedPaymentAmount =
        user?.paymentAmount !== undefined
          ? Number(user.paymentAmount).toFixed(2)
          : "";

      const formattedRrn = user?.rrn ? (
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "visible",
            textOverflow: "clip",
          }}
        >
          {user?.rrn}
        </td>
      ) : (
        ""
      );

      return {
        ...user,
        id: index + 1,

        transDate: transDateParsed
          ? [
              format(transDateParsed, "dd-MM-yyyy"),
              <br key={index} />,
              format(transDateParsed, "HH:mm:ss"),
            ]
          : "",

        paymentAmount: formattedPaymentAmount,

        rrn: formattedRrn ? formattedRrn : "",
      };
    });

    return modified;
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const onReset = () => {
    reset({
      companyCode: "",
      fromDate: "",
      toDate: "",
      fromAmount: "",
      toAmount: "",
      billerCategory: null,
      billerName: "",
      billerStatus: [],
      firstContactPersonMobileNo: "",
    });
    setFilterData({
      companyCode: "",
      fromDate: "",
      toDate: "",
      fromAmount: "",
      toAmount: "",
      billerCategory: null,
      billerName: "",
      billerStatus: [],
      firstContactPersonMobileNo: "",
    });
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                }}
              >
                <h5 className="modal-title main-title">Filter</h5>
                <HighlightOffIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <Box component="form">
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {[
                        "Company Code",
                        "Created Date",
                        "Amount",
                        "Service Type",
                        "Biller Name",
                        "Status",
                        // "Mobile No",
                      ].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content">
                      {selectedTab === "Company Code" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">Company Code</label>
                            <input
                              type="text"
                              placeholder="Enter Company Code"
                              className="dateInput"
                              value={filterData?.companyCode}
                              maxLength={20}
                              pattern="[A-Za-z0-9]+"
                              onChange={(e) => {
                                const val = e.target.value;
                                // Optional: Filter non-alphanumeric characters manually
                                const cleanedVal = val.replace(
                                  /[^a-zA-Z0-9]/g,
                                  ""
                                );
                                setFilterData((prev) => ({
                                  ...prev,
                                  companyCode: cleanedVal,
                                }));
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Created Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value, formValues) =>
                                  !value ||
                                  !formValues.toDate ||
                                  new Date(value) <=
                                    new Date(formValues.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, formValues) =>
                                  !formValues.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <div className="error-text">
                                      {errors.fromDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value, formValues) =>
                                  !value ||
                                  !formValues.fromDate ||
                                  new Date(value) >=
                                    new Date(formValues.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, formValues) =>
                                  !formValues.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <div className="error-text">
                                      {errors.toDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}

                      {selectedTab === "Amount" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            gap: "16px",
                            flexDirection: "row",
                          }}
                        >
                          <div className="dateField" style={{ flex: 1 }}>
                            <label className="dateLabel">From Amount</label>
                            <div className="dateInputWrapper">
                              <input
                                type="number"
                                placeholder="0.00"
                                value={filterData?.fromAmount}
                                min="0"
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "-" ||
                                    e.key === "+" ||
                                    e.key === "e"
                                  )
                                    e.preventDefault(); // block - and e
                                }}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (/^\d*\.?\d*$/.test(val) || val === "") {
                                    setFilterData((prev) => ({
                                      ...prev,
                                      fromAmount: val,
                                    }));
                                  }
                                }}
                                className="dateInput"
                              />
                            </div>
                          </div>

                          <div
                            className="dateField"
                            style={{ flex: 1, width: "100px" }}
                          >
                            <label className="dateLabel">To Amount</label>
                            <div className="dateInputWrapper">
                              <input
                                type="number"
                                placeholder="0.00"
                                value={filterData?.toAmount}
                                min="0"
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "-" ||
                                    e.key === "+" ||
                                    e.key === "e"
                                  )
                                    e.preventDefault(); // block - and e
                                }}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (/^\d*\.?\d*$/.test(val) || val === "") {
                                    setFilterData((prev) => ({
                                      ...prev,
                                      toAmount: val,
                                    }));
                                  }
                                }}
                                className="dateInput"
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {selectedTab === "Service Type" && (
                        <div className="dateField">
                          <label className="dateLabel">Service Type</label>
                          <div className="dateInputWrapper">
                            <select
                              value={filterData.billerCategory?.value || ""}
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                const selectedOption = serviceType.find(
                                  (opt) => opt.value === selectedValue
                                );
                                setFilterData((prev) => ({
                                  ...prev,
                                  billerCategory: selectedOption || null,
                                }));
                              }}
                              className="dateInput"
                            >
                              <option value="" disabled>
                                Select Service Type
                              </option>
                              {serviceType.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}

                      {selectedTab === "Biller Name" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">Biller Name</label>
                            <input
                              type="text"
                              placeholder="Enter Biller Name"
                              className="dateInput"
                              value={filterData?.billerName}
                              maxLength={20}
                              pattern="[A-Za-z0-9]+"
                              onChange={(e) => {
                                const val = e.target.value;
                                // Optional: Filter non-alphanumeric characters manually
                                const cleanedVal = val.replace(
                                  /[^a-zA-Z0-9]/g,
                                  ""
                                );
                                setFilterData((prev) => ({
                                  ...prev,
                                  billerName: cleanedVal,
                                }));
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Status" && (
                        <div className="dateField">
                          <label
                            className="dateLabel"
                            style={{
                              marginBottom: "0.5rem",
                              fontWeight: "600",
                              fontSize: "25px",
                            }}
                          >
                            Status
                          </label>
                          <div
                            className="dateInputWrapper"
                            style={{
                              display: "flex",
                              gap: "1rem",
                              flexWrap: "wrap",
                              padding: "0.75rem",
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #ced4da",
                              borderRadius: "0.5rem",
                            }}
                          >
                            {[
                              { label: "Pending", value: "P" },
                              { label: "Processing", value: "T" },
                              { label: "Success", value: "S" },
                              { label: "Failed", value: "F" },
                            ].map((status) => (
                              <label
                                key={status.value}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  // backgroundColor: "#fff",
                                  padding: "0.5rem 0.75rem",
                                  // border: "1px solid #dee2e6",
                                  borderRadius: "0.375rem",
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={filterData.billerStatus.includes(
                                    status.value
                                  )}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    setFilterData((prev) => ({
                                      ...prev,
                                      billerStatus: isChecked
                                        ? [...prev.billerStatus, status.value]
                                        : prev.billerStatus.filter(
                                            (v) => v !== status.value
                                          ),
                                    }));
                                  }}
                                  style={{ cursor: "pointer" }}
                                />
                                {status.label}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}

                      {selectedTab === "Mobile No" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <Controller
                              name="mobileNo"
                              control={control}
                              rules={{
                                minLength: {
                                  value: 10,
                                  message:
                                    "Mobile No must be at least 10 characters",
                                },
                                pattern: {
                                  value: /^[6-9]\d{9}$/,
                                  message:
                                    "Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9",
                                },
                                validate: {
                                  noRepeats: (value) =>
                                    !/^([a-zA-Z0-9])\1*$/.test(value) ||
                                    "Repeated characters are not allowed",
                                },
                              }}
                              render={({ field }) => (
                                <>
                                  <label className="dateLabel">Mobile No</label>
                                  <input
                                    {...field}
                                    type="text"
                                    placeholder="Enter Mobile No"
                                    className="dateInput"
                                    value={
                                      filterData.firstContactPersonMobileNo
                                    }
                                    onChange={(e) => {
                                      const val = e.target.value.replace(
                                        /[^a-zA-Z0-9]/g,
                                        ""
                                      );
                                      setFilterData((prev) => ({
                                        ...prev,
                                        firstContactPersonMobileNo: val,
                                      }));
                                      field.onChange(val);
                                    }}
                                    maxLength={10}
                                  />
                                  {errors.firstContactPersonMobileNo && (
                                    <div className="error-text">
                                      {
                                        errors.firstContactPersonMobileNo
                                          .message
                                      }
                                    </div>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <div
                      onClick={handleSubmit(onSubmit)}
                      className="btn btn-submit"
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Submit"
                      )}
                    </div>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustReportFilterModal;
